// extracted by mini-css-extract-plugin
export default {"ventures":"ventures__1QPWY"};